/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-dupe-keys */
import { createHashRouter, RouterProvider } from "react-router-dom";
import { Offline, Online } from "react-detect-offline";
import { Toaster } from "react-hot-toast";
import Layout from "./Components/Layout/Layout.jsx";
import Home from "./Components/Home/Home";
import Categories from "./Components/Categories/Categories";
import Cart from "./Components/Cart/Cart";
import Checkout from "./Components/Checkout/Checkout.jsx";
import Login from "./Components/Login/Login";
import Register from "./Components/Register/Register";
import Notfound from "./Components/Notfound/Notfound";
import "./App.css";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute.jsx";
import Brands from "./Components/Brands/Brands.jsx";
import ProductDetails from "./Components/ProductDetails/ProductDetails.jsx";
import { CartContextProvider } from "./Context/CartContext.js";
import FeaturedProducts from "./Components/FeaturedProducts/FeaturedProducts.jsx";
import BrandDetails from "./Components/BrandDetails/BrandDetails.jsx";
import ForgetPassword from "./Components/ForgetPassword/ForgetPassword.jsx";
import VerifyCode from "./Components/VerifyCode/VerifyCode.jsx";
import ResetPassword from "./Components/ResetPassword/ResetPassword.jsx";
export default function App() {
	let routers = createHashRouter([
		{
			path: "",
			element: <Layout />,
			children: [
				{
					index: true,
					element: (
						<ProtectedRoute>
							<Home />
						</ProtectedRoute>
					),
				},
				{
					path: "featuredProducts",
					element: (
						<ProtectedRoute>
							<FeaturedProducts />
						</ProtectedRoute>
					),
				},
				{
					path: "categories",
					element: (
						<ProtectedRoute>
							<Categories />
						</ProtectedRoute>
					),
				},
				{
					path: "cart",
					element: (
						<ProtectedRoute>
							<Cart />
						</ProtectedRoute>
					),
				},
				{
					path: "/brands",
					element: (
						<ProtectedRoute>
							<Brands />
						</ProtectedRoute>
					),
				},
				{
					path: "/brandDetails/:id",
					element: (
						<ProtectedRoute>
							<BrandDetails />
						</ProtectedRoute>
					),
				},
				{
					path: "/productDetails/:id",
					element: (
						<ProtectedRoute>
							<ProductDetails />
						</ProtectedRoute>
					),
				},
				{
					path: "/checkout",
					element: (
						<ProtectedRoute>
							<Checkout />
						</ProtectedRoute>
					),
				},
				{ path: "login", element: <Login /> }, // Pass function to login
				{ path: "register", element: <Register /> },
				{ path: "forgetPassword", element: <ForgetPassword /> },
				{ path: "verifycode", element: <VerifyCode /> },
				{
					path: "/resetPassword",
					element: <ResetPassword />,
				},
				{ path: "*", element: <Notfound /> },
			],
		},
	]);

	return (
		<CartContextProvider>
			<Toaster />
			<Online>Only shown when you're online</Online>
			<Offline>
				<div className='network'>Only shown offline (surprise!)</div>
			</Offline>
			<RouterProvider router={routers}></RouterProvider>
		</CartContextProvider>
	);
}
